import React, { useState, useEffect } from "react";
import MasterTable from "../../../components/common/MasterTable";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import Loader from "../../../components/Loader/Loader";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";
import AddStationaryModal from "./AddStationaryModal";

const defaultFilterData = {
  itemCode: "",
  itemName: "",
  isActive: null,
  fromDate: "",
  toDate: "",
};

const StationaryMaster = () => {
  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [vendorData, setVendorData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [pageDetails, setPageDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [auditData, setAuditData] = useState("");
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);
  const [showSequenceModal, setShowSequenceModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [columnData, setColumnData] = useState("");

  const handleReset = () => {
    setFilterData(defaultFilterData);
    // fetchVendorData(1, defaultFilterData);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const handleAuditData = (data) => {
    let venData = vendorData.find((item) => item?.id === data?.id);
    console.log("venData", venData);
    fetchUserAudit(venData);
  };

  const fetchUserAudit = async (venData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userCode: venData.vendorId,
      };

      const response = await axiosPostApi(
        `${apiList.VENDOR_AUDIT_DATA}`,
        requestBody,
      );
      console.log("FetchVendorAudit", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditDetails);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStationaryData(1, filterData);
  }, []);

  const fetchStationaryData = (
    currentPage,
    filters = filterData,
    size = pageSize,
  ) => {
    const payload = {
      username: loggedInUserName,
      // itemCode: filters.itemCode || "",
      // itemName: filters.itemName || "",
      // isActive: filters.isActive,
      // fromDate: formatDate(filters.fromDate),
      // toDate: formatDate(filters.toDate),
    };

    setLoading(true);

    axiosPostApi(
      `${apiList.FETCH_STATIONARY_MASTER}?&pageSize=${size}&pageNo=${currentPage}`,
      payload,
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setPageDetails(response?.data?.pageDetails);
          const modifiedData = modifyStructure(response?.data?.data);
          setVendorData(modifiedData);

          if (modifiedData?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setVendorData([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: item.id || index + 1,
      isActive: item.isActive ? "Active" : "Inactive",
    }));
  };

  const stationaryHeaders = [
    "Status",
    "Stationary Code",
    "Stationary Name",
    "Unit Rate (₹)",
    "GST %",
    "Min Qty – LMBP",
    "Min Qty – Sub-LMBP",
  ];

  const stationaryHeaderToKeyMap = {
    Status: "status",
    "Stationary Code": "itemCode",
    "Stationary Name": "itemName",
    "Unit Rate (₹)": "unitRate",
    "GST %": "gstPercent",
    "Min Qty – LMBP": "minQuantity",
    "Min Qty – Sub-LMBP": "subMinQuantity",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handlerVendor = (data, actionType = "view") => {
    setColumnData(data);
    if (actionType === "sequence") {
      const venData = vendorData.find((item) => item?.id === data?.id);
      setSelectedVendor(venData);
      setShowSequenceModal(true);
      return;
    }
    setModalAction(actionType);

    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else {
      let venData = vendorData.find((item) => item?.id === data?.id);
      if (venData) {
        setEditData(venData);
        setShowModal(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      <HeaderWithBreadcrumb title="Stationary Master" breadcrumb="Master" />
      <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              headers={stationaryHeaders}
              data={vendorData}
              handleAction={handlerVendor}
              filterFields={["itemName"]}
              entityType="Stationary"
              headerToKeyMap={stationaryHeaderToKeyMap}
              loading={loading}
              noData={noData}
              // handleAuth={handleAuthorization}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecord={totalRecord}
              fetchNextData={(page, size) =>
                fetchStationaryData(page, filterData, size)
              }
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              handleAuditData={handleAuditData}
              // openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => fetchStationaryData(1, defaultFilterData)}
            />
            {showModal && (
              <AddStationaryModal
                show={showModal}
                handleClose={handleCloseModal}
                editData={editData}
                // columnData={columnData}
                action={modalAction}
                callApi={() => fetchStationaryData(1, filterData, pageSize)}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StationaryMaster;
